import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';


const DownloadFiles19 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial19/tutorial19.zip?ref_type=heads&inline=false', download: 'tutorial19.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialNinetheen = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How To Control The Current Index Of QTabWidget Using QPushButton With PyQt6 And QtDesigner | LoadUi</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/X4-_i1QBK5I/maxresdefault.jpg"
                            alt="Tutorial 19"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this tutorial, you'll learn how to control the active tab of a QTabWidget using QPushButton in PyQt6, combined with a GUI created in Qt Designer. We'll guide you through the process of switching between tabs programmatically, loading the .ui file using uic.loadUi, and connecting button clicks to change the current index of the QTabWidget. This method helps you create dynamic, interactive tabbed interfaces in a clean and pythonic way.
                        <br /><strong>What you'll learn:</strong>
                        <ul>
                            <li>Loading .ui files with uic.loadUi</li>
                            <li>Using QPushButton to control QTabWidget index</li>
                            <li>Connecting signals and slots effectively</li>
                            <li>Building dynamic tabbed layouts for PyQt6 applications</li>
                        </ul>
                        Perfect for beginners and intermediate developers looking to enhance their GUI skills by adding interactive tab switching.
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #QTabWidget #QPushButton #LoadUI #DesktopApps #Programming #GUI
                    </p>

                    <button className="seemore">
                        <DownloadFiles19 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialNinetheen;
